<div class="footer">
    <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="center start">
        <div fxFlex="1200px" fxFlex.xs="90%" fxFlex.sm="90%" fxFlex.md="90%">
            <div fxLayout="row" fxLayout.xs="row wrap" fxLayout.sm="row wrap">
                <div fxFlex="25%" fxFlex.xs="100%" fxFlex.sm="50%">
                    <a [routerLink]="['/']"><img  class="logo" src="/assets/img/logo-01.svg" alt="Plaza Hogar" /></a>
                    <div class="social-media">
                        <a href="https://es-la.facebook.com/plazahogar.amvt/" target="_blank"><span class="jam jam-facebook"></span></a>
                        <a href="https://www.instagram.com/plazahogarok" target="_blank"><span class="jam jam-instagram"></span></a>
                    </div>
                </div>
                <div fxFlex="25%" fxFlex.xs="100%" fxFlex.sm="50%">
                    <mat-list role="list">
                        <mat-list-item role="listitem" fxShow.xs="true" fxHide><a target="_blank" href="http://amvtweb.ddns.net">Asociación Mutual</a></mat-list-item>
                        <mat-list-item role="listitem"><a [routerLink]="['/centro-de-ayuda']" target="_blank">Centro de ayuda</a></mat-list-item>
                        <mat-list-item role="listitem"><a [routerLink]="['/terminos-y-condiciones']" target="_blank">Términos y Condiciones</a></mat-list-item>
                        <mat-list-item role="listitem" fxHide fxShow.lt-md><a target="_blank" href="http://amvtweb.ddns.net">Asociación Mutual</a></mat-list-item>
                    </mat-list>
                </div>
                <div fxFlex="25%" fxHide.lt-md fxFlex.sm="50%">
                    <mat-list role="list">
                        <mat-list-item role="listitem"><a target="_blank" href="http://amvtweb.ddns.net">Asociación Mutual</a></mat-list-item>
                    </mat-list>
                </div>
                <div fxFlex="25%" fxFlex.xs="100%" fxFlex.sm="50%" class="text-align-center">
                    <a class="data-fiscal" href="http://amvtdatafiscal.ddns.net" target="_F960AFIPInfo"><img src="https://www.afip.gob.ar/images/f960/DATAWEB.jpg" border="0"></a>
                </div>
            </div>

            <hr fxHide.lt-md>
            <drag-scroll #footerCarousel drag-scroll-y-disabled="true" scrollbar-hidden="true">
                <div *ngFor="let office of offices" drag-scroll-item class="sucursal-container">
                    <div class="sucursal">
                        <h3>{{ office.title }}</h3>
                        <p *ngIf="office.phone"><small><span class="jam jam-viber"></span> {{ office.phone }}</small></p>
                        <p *ngIf="office.address"><small><span class="jam jam-map"></span> {{ office.address }}</small></p>
                        <p *ngIf="office.hours"><small><span class="jam jam-clock"></span> {{ office.hours }}</small></p>
                    </div>
                </div>
            </drag-scroll>

        </div>
    </div>
</div>


<div class="subfooter" fxLayoutAlign="center start">
    <div fxLayout="row" fxLayout.xs="column" fxFlex="1200px" fxFlex.xs="90%" fxFlex.sm="90%" fxFlex.md="90%">
        <mat-toolbar>
            <mat-toolbar-row>
                <p>Plaza Hogar @ {{ year }}. <br fxHide fxShow.xs> Todos los derechos reservados</p>
                <span class="example-spacer"></span>

                <div class="cards">
                    <img class="card" src="/assets/img/credit-cards/Maestro.png" alt="Maestro" />
                    <img class="card" src="/assets/img/credit-cards/cabal.png" alt="Cabal" />
                    <img class="card" src="/assets/img/credit-cards/Visa.png" alt="Visa" />
                    <img class="card" src="/assets/img/credit-cards/Mastercard.png" alt="Master Card" />
                    <img class="card" src="/assets/img/credit-cards/mutual-card.png" alt="Mutual Card" />
                </div>
            </mat-toolbar-row>
        </mat-toolbar>
    </div>
</div>
